export default __webpack_public_path__ + "static/Poppins-SemiBold-cce5625b56ec678e42021270b84ef400.ttf";